/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import {Container} from 'react-bootstrap'
import { Trans } from 'react-i18next';
import './homeTitle.scss'

export default function HomeTitle(props) {
    return (
        <Container>
            <div className="mn-title" >
                <h2 className="my-0"><Trans>{props.title}</Trans></h2>
                <span className="headline my-3"></span>
                <p css={`color: gray`}><Trans>{props.des}</Trans></p>
            </div>
        </Container>
    )
}
